import Trophy from "../../assets/icons-v2/trophy.svg";
import CustomSvg from "../common/custom-svg/custom-svg";
import Email from "../../assets/icons-v2/email.svg";
import Location from "../../assets/icons-v2/location.svg";
import Calendar from "../../assets/icons-v2/calendar.png";
import Profile from "../../assets/icons-v2/profile.svg";
import Logout from "../../assets/icons-v2/signout.svg";
import Help from "../../assets/icons-v2/help.svg";
import Share from "../../assets/icons-v2/share.svg";
import { AiOutlineHome } from "react-icons/ai";
import { MdOutlineGroups, MdOutlineHouse } from "react-icons/md";
import { FaPuzzlePiece } from "react-icons/fa";

const iconSize = { height: 25, width: 25 };

export const SIDEMENU_ITEMS = [
    {
        label: "My Profile",
        url: "",
        icon: <CustomSvg src={Profile} size={iconSize} />,
        isRegistered: true,
        hidden: true,
    },
    {
        label: "Sign In",
        url: "",
        icon: <CustomSvg src={Profile} size={iconSize} />,
        isRegistered: false,
        hidden: true,
    },
    {
        label: "Switch Location",
        url: "",
        icon: <CustomSvg src={Location} size={iconSize} />,
        isRegistered: true,
        hidden: true,
    },
    {
        label: "Home",
        url: "/",
        icon: <AiOutlineHome size={25} />,
    },
    {
        label: "Social",
        url: "/social",
        icon: <MdOutlineGroups size={25} />,
    },
    {
        label: "Puzzle",
        url: "/puzzle",
        icon: <FaPuzzlePiece size={25} />,
    },
    {
        label: "Classic",
        url: "/classic",
        icon: <MdOutlineHouse size={25} />,
    },
    {
        label: "Leaderboard & Stats",
        url: `/leaderboard`,
        icon: <CustomSvg src={Trophy} size={iconSize} />,
    },
    {
        label: "Invite a friend",
        url: ``,
        icon: <CustomSvg src={Share} size={iconSize} />,
        hidden: true,
    },
    {
        label: "Send Feedback",
        url: `mailto:feedback@priceme.game?subject=${encodeURIComponent("Feedback for PriceMe")}`,
        icon: <CustomSvg src={Email} size={iconSize} />,
    },
    {
        label: "FAQ",
        url: "/faq",
        icon: <CustomSvg src={Help} size={iconSize} />,
        hidden: true,
    },
    {
        label: "Sign Out",
        url: "",
        icon: <CustomSvg src={Logout} size={iconSize} />,
        isRegistered: true,
        hidden: true,
    },
];

export const LIVE_VARIANT_SIDEMENU_ITEMS = [
    {
        label: "Back to Daily Game",
        url: "",
        icon: <CustomSvg src={Trophy} size={iconSize} />,
        hidden: true,
    },
    {
        label: "Choose Area",
        url: "",
        icon: <CustomSvg src={Location} size={iconSize} />,
        hidden: true,
    },
    {
        label: "Play archives",
        url: "",
        icon: <CustomSvg src={Calendar} size={iconSize} />,
        hidden: true,
    },
    {
        label: "Send Feedback",
        url: `mailto:feedback@priceme.game?subject=${encodeURIComponent("Feedback for PriceMe")}`,
        icon: <CustomSvg src={Email} size={iconSize} />,
    },
    {
        label: "Leaderboard & Stats",
        url: "/leaderboard",
        icon: <CustomSvg src={Trophy} size={iconSize} />,
    },
];
